import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import { WorkviewsRoutePage } from "../app/workviewsRoute";

export const Route = createFileRoute("/workviews")({
  component: WorkviewsRoute,
});

function WorkviewsRoute(): JSX.Element {
  const search = Route.useSearch();
  return <WorkviewsRoutePage search={search} />;
}
